import React from 'react'
import SEOHead from '../components/SEOHead'
import HeroSection from '../components/HomePage/HeroSection'
import AboutBrief from '../components/HomePage/AboutBrief'
import FeaturedServices from '../components/HomePage/FeaturedServices'
import WhyChooseUs from '../components/HomePage/WhyChooseUs'
import PortfolioShowcase from '../components/HomePage/portfolioprofessional'
import ClientTestimonials from '../components/HomePage/ClientTestimonials'

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEOHead 
        title="Vector Visionary - Professional Vector Art Services | Logo Design & Embroidery"
        description="Transform your designs with our expert vector art services for logos, embroidery, and custom patches. Professional digitization, vector conversion, and patch design services."
        keywords="vector art, logo design, embroidery digitization, custom patches, vector conversion, graphic design, professional design services"
        url="https://vectorvisionary.com/"
      />
      <HeroSection />
      <AboutBrief />
      <FeaturedServices />
      <PortfolioShowcase />
      <WhyChooseUs />
      <ClientTestimonials />
    </div>
  )
}

export default HomePage
